import { t } from '@lingui/macro'
import { Period } from './period'

export const getAutoRenewPeriodicityText = (periodicity: Period) => {
  if (periodicity === Period.Yearly)
    return t`* Recurring payment, renews every year`
  return t`* Recurring payment, renews every month`
}
